import Modal from 'elements/modal';
import Button from 'elements/button';

import exclamationIcon from 'assets/images/exclamation-mark.png';

import './CancelOrderModal.scss';

type Props = {
  onClose: Function;
  onSubmit: Function;
  show: boolean;
};

const CancelOrderModal = ({ onClose, onSubmit, show }: Props) => {
  return (
    <Modal onClose={() => onClose(false)} show={show}>
      <div className="cancel-order-modal">
        <img className="cancel-order-modal-icon" src={exclamationIcon} alt="exclamation" />
        <p className="cancel-order-modal-title">{_t('Cancel Order?', 'MODAL.CANCEL_ORDER')}</p>
        <p className="cancel-order-modal-description">
          {_t(
            'The remaining asset balance and fees will be returned to your wallet on the cancellation of this order.',
            'MODAL.CANCEL_ORDER_DESCRIPTION'
          )}
        </p>
        <p className="cancel-order-modal-proceed">{_t('Would you like to proceed?', 'MODAL.CANCEL_ORDER_PROCEED')}</p>
        <div className="cancel-order-modal-buttons">
          <Button clickHandler={onSubmit} size="sm">
            {_t('Yes', 'GENERAL.YES')}
          </Button>
          <Button clickHandler={() => onClose(false)} color="blue" size="sm">
            {_t('No', 'GENERAL.NO')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CancelOrderModal;
